<template>
    <div>
        <v-container fluid class="d-print-none">
            <v-row>
                <v-col cols="12" sm="8" md="5">
                    <v-form method="post" id="nativeForm" v-model="valid">
                        <v-card>
                            <v-container fluid>
                                <v-row>
                                    <v-col cols="12">
                                        <h3>Export Report</h3>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-menu
                                            v-model="modal"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                    v-model="dateRangeText"
                                                    label="Date range"
                                                    readonly
                                                    v-on="on"
                                                    :rules="dateR"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                style="
                                                    min-width: 0px !important;
                                                    width: 420px;
                                                "
                                                v-model="form_search.date"
                                                range
                                                @change="get_date()"
                                            ></v-date-picker>
                                        </v-menu>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-progress-linear
                                            v-if="chk_export === true"
                                            indeterminate
                                            color="cyan"
                                        ></v-progress-linear>
                                        <v-btn
                                            v-if="chk_export === false"
                                            block
                                            color="green accent-3"
                                            class="mt-4"
                                            @click="export_data(2)"
                                            :disabled="!valid"
                                        >
                                            report gps
                                        </v-btn>
                                        <v-btn
                                            v-if="chk_export === false"
                                            block
                                            color="green accent-3"
                                            class="mt-4"
                                            @click="export_data(1)"
                                            :disabled="!valid"
                                        >
                                            Report IT
                                        </v-btn>
                                        <v-btn
                                            block
                                            class="mt-3"
                                            @click="refresh_data(1)"
                                            >Refresh</v-btn
                                        >
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card>
                    </v-form>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
import axios from "axios"

const url = `${process.env.VUE_APP_ROOT_API}/api/`
import { mapState, mapMutations } from "vuex"

export default {
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
    },
    mounted() {
        // console.log(this.form_search.date_type)
    },
    computed: {
        ...mapState(["isLoading"]),

        dateRangeText() {
            this.form_search.date.sort((a, b) => {
                return new Date(a) - new Date(b)
            })

            return this.form_search.date.join(" ~ ")
        },
    },
    methods: {
        ...mapMutations(["mutateIsLoading"]),

        get_date() {
            if (this.dateRangeText.length === 23) {
                this.modal = false
            }
        },

        async export_data(st) {
            let url_report
            let data_export
            if (st == 1) {
                this.chk_export = true
                url_report = "it/export/report"
                data_export = this.form_search
            } else if (st == 2) {
                this.chk_export = true
                url_report = "it/export/report-compare"
                data_export = this.form_search
            }

            await axios({
                url: url + url_report,
                method: "POST",
                responseType: "blob",
                data: data_export,
                headers: { Authorization: "Bearer " + localStorage.token },
            }).then((response) => {
                let fileURL = window.URL.createObjectURL(
                    new Blob([response.data])
                )
                let fileLink = document.createElement("a")

                fileLink.href = fileURL
                fileLink.setAttribute("download", "report.xlsx")
                document.body.appendChild(fileLink)

                fileLink.click()
                this.chk_export = false
            })
        },

        refresh_data(st) {
            if (st == 1) {
                this.form_search.date_type = null
                this.form_search.date = []
                this.form_search.project = []
                this.form_search.zone = []
                this.form_search.sub_type = null
                this.form_search.layout = "raw"
            }
        },
    },
    data() {
        return {
            chk_export: false,

            tk: null,

            modal: false,
            form_search: {
                date: [],
            },

            valid: false,

            dateR: [(v) => !!v || "Dates  is required"],
        }
    },
}
</script>
